import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import AdminDashboard from "./admin/Pages/kibanaDashboard";

import SignUp from "layouts/authentication/sign-up";

import Shop from "examples/Icons/Shop";
import BusinessProfile from "layouts/businessList";
import Ratingandreviews from "layouts/ratingandreviews";
import Offers from "layouts/offers";
import { Business, Dns, Shop2Outlined, ShopOutlined } from "@mui/icons-material";
import StarIcon from '@mui/icons-material/Star';
import RedeemIcon from '@mui/icons-material/Redeem';
import BusinessDetail from "layouts/businessDetail"
import OfferDetail from "layouts/offerDetail"
import ForgetPassword from "layouts/authentication/forgot";
import Subscriptions from "layouts/Subscriptions";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SearchIcon from "@mui/icons-material/Search";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PeopleIcon from "@mui/icons-material/People";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CategoryIcon from "@mui/icons-material/Category";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ChatIcon from "@mui/icons-material/Chat";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ReviewsIcon from "@mui/icons-material/Reviews";
import KibanaDashboard from "./admin/Pages/kibanaDashboard";
import KibanaSearch from "./admin/Pages/kibanaSearch";
import BusinessUsers from "./admin/Pages/businessUsers";
import AddBusinessUsers from "./admin/Pages/businessUsers/AddForm";
import DetailBusinessUser from "./admin/Pages/businessUsers/detail";
import Users from "./admin/Pages/users";
import UsersDetail from "./admin/Pages/users/detail";
import Amenities from "./admin/Pages/amenities";
import Keywords from "./admin/Pages/keywords";
import Categories from "./admin/Pages/categories";
import SubCategories from "./admin/Pages/categories/subCategory";
import AddSubCategory from "./admin/Pages/categories/AddSubCategory";
import PushNotification from "./admin/Pages/pushNotification";
import AddFormNotification from "./admin/Pages/pushNotification/addForm";
import Complaints from "./admin/Pages/complaints";
import ComplaintDetail from "./admin/Pages/complaints/detail";
import IssueReportDetail from "./admin/Pages/issueReports/detail";
import UpdateListingDetail from "./admin/Pages/updateListing/detail";
import IssueReports from "./admin/Pages/issueReports";
import UpdateListing from "./admin/Pages/updateListing";
import ReviewList from "./admin/Pages/reviewList";
import BusinessReviews from "./admin/Pages/businessReviews";
import AdminOffer from "./admin/Pages/offer";
import AdminOfferDetail from "./admin/Pages/offer/detail";
import AddOffer from "./admin/Pages/offer/AddOffer";
import AddAmenities from "./admin/Pages/amenities/AddAmenities";
import AddKeywords from "./admin/Pages/keywords/AddKeywords";
import AddCategories from "./admin/Pages/categories/AddCategories";
import AddReview from "./admin/Pages/reviewList/AddReview";
import ResetPassword from "layouts/authentication/resetPassword";
import VerifyEmail from "layouts/authentication/verifyEmail";

import GridViewIcon from '@mui/icons-material/GridView';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import BugReportIcon from '@mui/icons-material/BugReport';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import AutoGraphIcon from '@mui/icons-material/AutoGraph'
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Dns size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
    scope: "2",
  },
  {
    type: "collapse",
    name: "Business Profile",
    key: "business-Profile",
    route: "/business-Profile",
    icon: <Business size="12px" />,
    component: <BusinessProfile />,
    noCollapse: true,
    scope: "2",
  },
  {
    type: "collapse",
    name: "Ratings & Reviews",
    key: "Ratings-&-Reviews",
    route: "/Ratings-&-Reviews",
    icon: <StarIcon size="12px" />,
    component: <Ratingandreviews />,
    noCollapse: true,
    scope: "2",
  },
  {
    type: "collapse",
    name: "Offers",
    key: "offers",
    route: "/offers",
    icon: <RedeemIcon size="12px" />,
    component: <Offers />,
    noCollapse: true,
    scope: "2",
  },
  {
    route: "/subscriptions",
    component: <Subscriptions />,
    scope: "2",
  },
  {
    route: "/profile",
    key: "profile",
    component: <Profile />,
    scope: "2",
  },
  {
    route: "/forgot-password",
    component: <ForgetPassword />,
    scope: "2",
  },
  {
    route: "/offerDetail/:id",
    component: <OfferDetail />,
    scope: "2",
  },
  {
    route: "/business/detail/:id",
    component: <BusinessDetail />,
    scope: "2",
  },
  {
    route: "/login",
    component: <SignIn />,
    scope: "2",
  },
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   scope: '1',
  //   key: "admin/dashboard",
  //   route: "/admin/dashboard",
  //   icon: <Dns size="12px" />,
  //   component: <AdminDashboard />,
  //   noCollapse: true,
  // },
  // existing routes...


  {
    type: "collapse",
    name: "Kibana Dashboard",
    key: "dashboard",
    route: "/admin/dashboard",
    icon: <DashboardIcon size="12px" />,
    component: <AdminDashboard />,
    noCollapse: true,
    scope: "1",
  },
  {
    type: "collapse",
    name: "Elastic Search",
    key: "kibana-search",
    route: "/admin/elastic-search",
    icon: <SearchIcon size="12px" />,
    component: <KibanaSearch />,
    noCollapse: true,
    scope: "1",
  },
  {
    type: "collapse",
    name: "Business Users",
    key: "business-users",
    route: "/admin/business-users",
    icon: <BusinessCenterIcon size="12px" />,
    component: <BusinessUsers />,
    noCollapse: true,
    scope: "1",
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    route: "/admin/users",
    icon: <PeopleIcon size="12px" />,
    component: <Users />,
    noCollapse: true,
    scope: "1",
  },
 
  {
    type: "collapse",
    name: "Offers",
    key: "offer",
    route: "/admin/offer",
    icon: <CardGiftcardIcon size="12px" />,
    component: <AdminOffer />,
    noCollapse: true,
    scope: "1",
  },
  {
    type: "collapse",
    name: "Amenities",
    key: "amenities",
    route: "/admin/amenities",
    icon: <ApartmentIcon size="12px" />,
    component: <Amenities />,
    noCollapse: true,
    scope: "1",
  },
  {
    type: "collapse",
    name: "Keywords",
    key: "keywords",
    route: "/admin/keywords",
    icon: <GridViewIcon size="12px" />,
    component: <Keywords />,
    noCollapse: true,
    scope: "1",
  },
  {
    type: "collapse",
    name: "Categories",
    key: "categories",
    route: "/admin/categories",
    icon: <CategoryIcon size="12px" />,
    component: <Categories />,
    noCollapse: true,
    scope: "1",
  },
 
  {
    type: "collapse",
    name: "Push Notification",
    key: "push-notification",
    route: "/admin/push-notification",
    icon: <NotificationsActiveIcon size="12px" />,
    component: <PushNotification />,
    noCollapse: true,
    scope: "1",
  },

 
  {
    type: "collapse",
    name: "Requests",
    key: "requests",
    icon: <ClearAllIcon size="12px" />,
    noCollapse: false,
    scope: "1",
    open: true, // or control via state if needed
    collapse: [
      {
        type: "collapse",
        name: "Customer Support",
        key: "complaints",
        route: "/admin/complaints",
        icon: <ReportProblemIcon size="12px" />,
        noCollapse: true,
        scope: "1",
        component: <Complaints />,
      },
      {
        type: "collapse",
        name: "Issue Reports",
        key: "issue-reports",
        route: "/admin/issue-reports",
        icon: <BugReportIcon  size="12px" />,
        noCollapse: true,
        scope: "1",
        component: <IssueReports />,
      },
      {
        type: "collapse",
        name: "Update Listing",
        key: "update-listing",
        route: "/admin/update-listing",
        icon: <ListAltIcon size="12px" />,
        noCollapse: true,
        scope: "1",
        component: <UpdateListing />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Review",
    key: "review",
    icon: <StarHalfIcon size="12px" />,
    noCollapse: false,
    scope: "1",
    open: true, // or control via state if needed
    collapse: [
      {
        type: "collapse",
        name: "Review List",
        key: "review-list",
        route: "/admin/review-list",
        icon: <ReviewsIcon size="12px" />,
        noCollapse: true,
        scope: "1",
        component: <ReviewList />,

      },
      {
        type: "collapse",
        name: "Business Reviews",
        key: "business-reviews",
        route: "/admin/business-reviews",
        icon: <AutoGraphIcon  size="12px" />,
        noCollapse: true,
        scope: "1",
        component: <BusinessReviews />,

      },
    ],
  },

  ///// end list /////

  {
    route: "/admin/edit-offer/:id",
    component: <AddOffer />,
    scope: "1",
  },
  {
    route: "/admin/detail-business-user/:id",
    component: <DetailBusinessUser />,
    scope: "1",
  },
  {
    route: "/admin/detail-user/:id",
    component: <UsersDetail />,
    scope: "1",
  }, {
    route: "/admin/offer-detail/:id",
    component: <AdminOfferDetail />,
    scope: "1",
  },
  {
    route: "/admin/edit-bussiness-user/:id",
    component: <AddBusinessUsers />,
    scope: "1",
  },
  {
    route: "/admin/edit-amenities/:id",
    component: <AddAmenities />,
    scope: "1",
  },
  {
    route: "/admin/edit-keywords/:id",
    component: <AddKeywords />,
    scope: "1",
  },
  {
    route: "/admin/complaint-detail/:id",
    component: <ComplaintDetail />,
    scope: "1",
  },
  {
    route: "/admin/issue-detail/:id",
    component: <IssueReportDetail />,
    scope: "1",
  },
  {
    route: "/admin/update-detail/:id",
    component: <UpdateListingDetail />,
    scope: "1",
  },
  {
    route: "/admin/edit-categories/:id",
    component: <AddCategories />,
    scope: "1",
  },
  {
    route: "/admin/edit-review/:id",
    component: <AddReview />,
    scope: "1",
  },
  {
    route: "/admin/subcategory/:id",
    component: <SubCategories />,
    scope: "1",
  }, {
    route: "/admin/edit-subCategory/:id",
    component: <AddSubCategory />,
    scope: "1",
  },


  {
    route: "/admin/add-offer",
    component: <AddOffer />,
    scope: "1",
  },
  {
    route: "/admin/add-notification",
    component: <AddFormNotification />,
    scope: "1",
  },
  {
    route: "/admin/add-amenities",
    component: <AddAmenities />,
    scope: "1",
  },
  {
    route: "/admin/add-keywords",
    component: <AddKeywords />,
    scope: "1",
  },
  {
    route: "/admin/add-categories",
    component: <AddCategories />,
    scope: "1",
  }, 
  {
    route: "/admin/add-sub-categories",
    component: <AddSubCategory />,
    scope: "1",
  },
  {
    route: "/admin/add-review",
    component: <AddReview />,
    scope: "1",
  },


  // {
  //   route: "/admin/login",
  //   component: <AdminSignIn />,
  //   scope: "1",
  // },


  {
    route: "/register",
    component: <SignUp />,
    scope: "2",
  },
  {
    route: "/verifyEmail",
    component: <VerifyEmail />,
    scope: "2",
  },
  {
    route: "/resetPassword",
    component: <ResetPassword />,
    scope: "2",
  },
];

export default routes;














